import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-yes-no-popup',
  templateUrl: './yes-no-popup.component.html',
  styleUrls: ['./yes-no-popup.component.scss'],
})
export class YesNoPopupComponent implements OnInit {

  @Input() userMail?:string="";
  @Input() cigarName?:string="";
  @Input() questionType:string; /*send-activation-mail,continue-smoking-protocol,
  new-cigar-na, update-cigar-na, remove-entry-after-sp, really-delete, really-delete-humi,
  wanna-buy-capacity, delete-sp, get-params-from-former-sp, sync-prot-images,really-send-csv, install-pwa,
  delete-history-entry

  */


  constructor(private popc:PopoverController) {

  }

  ngOnInit() {
  }

  /**
   * Wir geben die Antwort auf unsere JA/NEIN Frage als boolean zurück
   * @param answer
   */
  public answer(answer:boolean){
    let answerData:object=null;
    //wurde Checkbox angehakt? (keine Nachrichten mehr bez. Löschung)
    let smCB:HTMLIonCheckboxElement=document.querySelector('#show_message');
    if(smCB!==null){
      answerData={
        'answer':answer,
        'no_messages':smCB.checked
      }
      this.popc.dismiss({
        answerData
      });
    }
    else{
      this.popc.dismiss({
        answer
      });
    }
  }

  /**
   * Nein-Button ausblenden, wenn keine NAchrichten mehr angezeigt werden sollen
   */
  toggleNo(){
    if(document.getElementById("no-button").style.display!=="none"){
      document.getElementById("no-button").style.display="none";
    }
    else{
      document.getElementById("no-button").style.display="block";
    }
  }

}
